import { Switch } from "../ui/switch";
import { SectionCard } from "./_shared";

const SECTIONS = [
  { key: "hero", label: "Hero (topo da página)" },
  { key: "stats", label: "Estatísticas / números" },
  { key: "audience", label: "Para Quem É (público)" },
  { key: "bmiCalculator", label: "Calculadora de IMC" },
  { key: "method", label: "Método (6 fases)" },
  { key: "photoGallery", label: "Galeria de Fotos" },
  { key: "videoGallery", label: "Galeria de Vídeos" },
  { key: "beforeAfter", label: "Antes & Depois (slider)" },
  { key: "testimonials", label: "Depoimentos" },
  { key: "included", label: "O Que Está Incluído" },
  { key: "bonus", label: "Bônus" },
  { key: "pricing", label: "Investimento / Planos" },
  { key: "about", label: "Sobre Mim" },
  { key: "leadCapture", label: "Formulário de Leads" },
  { key: "guarantee", label: "Garantia" },
  { key: "faq", label: "FAQ" },
  { key: "externalLinks", label: "Links Externos (Linktree)" },
  { key: "stickyCta", label: "Barra CTA fixa no scroll" },
  { key: "cookieConsent", label: "Banner de Cookies/LGPD" },
  { key: "whatsappFloat", label: "Botão flutuante WhatsApp" },
];

export default function EditVisibility({ value, onChange }) {
  const v = value || {};
  const set = (key, on) => onChange({ ...v, [key]: on });
  return (
    <SectionCard title="Visibilidade das Seções (Ativar / Desativar)">
      <p className="text-sm text-onyx/60 mb-6">
        Use os interruptores para mostrar ou ocultar cada seção da landing page. Desative o que não estiver pronto ou não fizer sentido para o seu serviço.
      </p>
      <div className="grid sm:grid-cols-2 gap-3">
        {SECTIONS.map((s) => {
          const on = v[s.key] !== false;
          return (
            <label
              key={s.key}
              data-testid={`visibility-row-${s.key}`}
              className="flex items-center justify-between gap-3 p-4 border border-border bg-white hover:border-gold transition-colors"
            >
              <span className="text-sm text-onyx">{s.label}</span>
              <Switch
                data-testid={`visibility-switch-${s.key}`}
                checked={on}
                onCheckedChange={(checked) => set(s.key, checked)}
              />
            </label>
          );
        })}
      </div>
    </SectionCard>
  );
}
